export default __webpack_public_path__ + "static/media/videoCall.e85809d2.jpg";